// src/App.js
import React from 'react';
import './css/modules/variables.css';
import { Routes, Route, Navigate } from 'react-router-dom';

import Regulamin from './components/Regulamin';
import PrivacyPolicy from './components/PrivacyPolicy';
import Homepage from './components/Homepage';
import Kontakt from './components/Kontakt';
import GoogleTag from './components/GoogleTag';
import TreningUS from './components/TreningUS';
import ZaburzeniaNiemowlat from './components/ZaburzeniaNiemowlat';
import TerapiaReki from './components/TerapiaReki';
import KiedyDoTerapeuty from './components/KiedyDoTerapeuty';
import FAQ from './components/FAQ';
import TestSensomotoryczny from './components/TestSensomotoryczny';
import Kwestionariusz from './components/Kwestionariusz';
import DiagnozaOlsztyn from './components/DiagnozaOlsztyn';
import TerapiaOlsztyn from './components/TerapiaOlsztyn';
import Cennik from './components/Cennik';
import Poradnie from './components/Poradnie';
import Krzyzowki from './components/Krzyzowki';
import OMnie from './components/OMnie';
import Layout from './components/Layout';
import NotFound from './components/NotFound';

/*
 * Adresy wycofane. Wlasciwe przekierowanie 301 robi Apache (server-level,
 * zgodnie ze spec sekcja 3) - te wpisy sa awaryjne: obsluguja sytuacje,
 * w ktorej uzytkownik trafi na stary adres juz wewnatrz aplikacji.
 */
const PRZEKIEROWANIA = [
  ['/diagnoza-si', '/diagnoza-sensoryczna-olsztyn/'],
  ['/diagnoza-sensoryczna', '/diagnoza-sensoryczna-olsztyn/'],
  ['/diagnoza-si-olsztyn', '/diagnoza-sensoryczna-olsztyn/'],
  ['/badanie-integracji-sensorycznej-olsztyn', '/diagnoza-sensoryczna-olsztyn/'],
  ['/diagnoza-integracji-sensorycznej-olsztyn', '/diagnoza-sensoryczna-olsztyn/'],
];

function App() {
  const WHY_PATH = process.env.REACT_APP_PATH_WHY_WE;

  return (
    <>
      <GoogleTag />
      <Layout>
        <Routes>
          <Route path="/" element={<Homepage />} />
          {WHY_PATH && <Route path={WHY_PATH} element={<Homepage />} />}

          {/* --- strony ofertowe (jedna intencja na adres) --- */}
          <Route path="/diagnoza-sensoryczna-olsztyn" element={<DiagnozaOlsztyn />} />
          <Route path="/terapia-integracji-sensorycznej-olsztyn" element={<TerapiaOlsztyn />} />
          <Route path="/cennik" element={<Cennik />} />

          {/* --- zaufanie i kontakt --- */}
          <Route path="/o-mnie" element={<OMnie />} />
          <Route path="/kontakt" element={<Kontakt />} />

          {/* --- narzedzia (noindex) --- */}
          <Route path="/kwestionariusz-sensomotoryczny" element={<Kwestionariusz />} />
          <Route path="/test-sensomotoryczny" element={<TestSensomotoryczny />} />

          {/* --- poradnik --- */}
          <Route path="/zaburzenia-niemowlat" element={<ZaburzeniaNiemowlat />} />
          <Route path="/trening-umiejetnosci-spolecznych" element={<TreningUS />} />
          <Route path="/terapia-reki" element={<TerapiaReki />} />
          <Route path="/kiedy-do-terapeuty" element={<KiedyDoTerapeuty />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/krzyzowki" element={<Krzyzowki />} />
          <Route path="/poradnie-psychologiczne" element={<Poradnie />} />

          {/* --- dokumenty --- */}
          <Route path="/regulamin" element={<Regulamin />} />
          <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />

          {PRZEKIEROWANIA.map(([from, to]) => (
            <Route key={from} path={from} element={<Navigate to={to} replace />} />
          ))}

          {/* Nieznany adres. Serwer zwraca dla niego status 404 i plik
              build/404.html, ktory prerender generuje wlasnie z tej trasy. */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    </>
  );
}

export default App;
